import oidcConfig from "../services/oidcConfig";

type AuthProfile = {
  preferred_username?: string;
} & Record<string, unknown>;

interface AuthData {
  idToken: string | null;
  accessToken: string | null;
  refreshToken: string | null;
  profile: AuthProfile | null;
}

const getSessionKey = () => `oidc.user:${oidcConfig.authority}:${oidcConfig.clientId}`;

const toNullableString = (value: unknown) => (typeof value === "string" ? value : null);

const toAuthProfile = (value: unknown): AuthProfile | null =>
  value && typeof value === "object" ? (value as AuthProfile) : null;

const getAuthData = (): AuthData | undefined => {
  const sessionData = sessionStorage.getItem(getSessionKey());

  if (!sessionData) {
    return undefined;
  }

  try {
    const parsedData = JSON.parse(sessionData) as Record<string, unknown>;
    const { id_token, access_token, refresh_token, profile } = parsedData;

    return {
      idToken: toNullableString(id_token),
      accessToken: toNullableString(access_token),
      refreshToken: toNullableString(refresh_token),
      profile: toAuthProfile(profile),
    };
  } catch (error) {
    console.error("Unable to parse auth session data", error);
    return undefined;
  }
};

export const getIdToken = () => getAuthData()?.idToken ?? null;

export const getAccessToken = () => getAuthData()?.accessToken ?? null;

export const getRefreshToken = () => getAuthData()?.refreshToken ?? null;

export const getProfileData = () => getAuthData()?.profile ?? null;

export const getUserId = () => getAuthData()?.profile?.preferred_username ?? null;

export default getAuthData;
